import React, { useState, useEffect } from 'react'
import { Panel, Row, Form, Col, Checkbox, ButtonGroup, IconButton, Icon, Table } from 'rsuite'

export default function CenterChangeFormAttach({
  attachFiles,
  titel = 'เอกสารแนบขอนุมัติแก้ไขสัญญา',
  isView,
  isFilter,
  isEnableDel,
  forceSelected = [],
  setTableSelected = () => {},
  onDownload = () => {},
  onPreview = () => {},
  onDelete = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [checkedKeys, setCheckedKeys] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [datas, setDatas] = useState([])

  useEffect(() => {
    if (
      attachFiles?.selected?.length > 0 &&
      attachFiles?.selected?.length < attachFiles?.value?.length
    ) {
      setCheckedKeys(attachFiles?.selected)
    } else if (
      attachFiles?.selected?.length == attachFiles?.value?.length &&
      attachFiles?.selected?.length > 0
    ) {
      setCheckedKeys(attachFiles?.selected)
      setIndeterminate(true)
    } else {
      setCheckedKeys([])
      setIndeterminate(false)
    }
  }, [])

  useEffect(() => {
    setDatas(
      isFilter
        ? (attachFiles?.value || []).filter((e) => attachFiles?.selected?.includes(e.id))
        : attachFiles?.value || []
    )
  }, [attachFiles])

  const handleCheckAll = (value, checked) => {
    // let newArr = []
    const checkedKeys = checked
      ? attachFiles?.value.filter((e) => !forceSelected.includes(e)).map((item) => item.id)
      : []

    setCheckedKeys(checkedKeys)
    setTableSelected(checkedKeys)

    if (checkedKeys?.length === 0) {
      setIndeterminate(false)
    } else {
      setIndeterminate(true)
    }
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    setCheckedKeys(nextCheckedKeys)
    setTableSelected(nextCheckedKeys)

    if (nextCheckedKeys?.length === attachFiles?.value?.length) {
      setIndeterminate(true)
    } else {
      setIndeterminate(false)
    }
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    var forceCheck = forceSelected?.includes(rowData[dataKey])
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey]) || forceCheck}
            style={{ marginLeft: -30 }}
            disabled={forceCheck}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  return (
    <>
      <Row style={{ marginTop: 10 }}>
        {attachFiles && (
          <Col xs={24} sm={24} md={24} lg={24}>
            <b style={{ marginTop: 8 }}>{titel}</b>

            <Table
              height={400}
              autoHeight={datas?.length <= 5}
              wordWrap
              bordered
              data={datas}
              style={{ marginBottom: 10 }}
            >
              {isView ? (
                <Column width={95} align="center">
                  <HeaderCell>ลำดับ</HeaderCell>
                  <Cell>
                    {(_, index) => {
                      return index + 1
                    }}
                  </Cell>
                </Column>
              ) : (
                <Column width={95} align="center">
                  <HeaderCell style={{ padding: 0 }}>
                    <Checkbox
                      inline
                      checked={props.value}
                      indeterminate={indeterminate}
                      onChange={(e, checked) => {
                        handleCheckAll(null, checked)
                      }}
                      style={{ marginLeft: -10 }}
                    >
                      <b>ลำดับ</b>
                    </Checkbox>
                  </HeaderCell>

                  <CheckCell
                    dataKey="id"
                    checkedKeys={checkedKeys}
                    onChange={(value, checked) => {
                      handleCheck(value, checked)
                    }}
                  />
                </Column>
              )}

              <Column width={380}>
                <HeaderCell>ชื่อไฟล์</HeaderCell>
                <Cell dataKey="label" />
              </Column>

              <Column width={380} flexGrow={1}>
                <HeaderCell>ประเภทไฟล์</HeaderCell>
                <Cell dataKey="contractFileType" />
              </Column>

              <Column width={150} align="center" fixed="right">
                <HeaderCell></HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={(e) => {
                            if (rowData.file) {
                              const url = URL.createObjectURL(rowData.file.blobFile)
                              window.open(url)
                            } else {
                              onPreview(rowData)
                            }
                          }}
                        />
                        {rowData.id && (
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                            onClick={(e) => onDownload(rowData)}
                          />
                        )}

                        {isEnableDel && (
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />}
                            className="rs-btn-ghost-cancel"
                            onClick={(e) => onDelete(rowData, index)}
                          />
                        )}
                      </ButtonGroup>
                    )
                  }}
                </Cell>
              </Column>
            </Table>
          </Col>
        )}
      </Row>
    </>
  )
}
